import * as z from "zod";

import { lineSchema } from "./line";

export const departureSchema = z.object({
  direction: z.string(),
  display: z.string(),
  expected: z.coerce.date().optional(),
  scheduled: z.coerce.date(),
  line: lineSchema,
  stop_area: z.object({
    id: z.number(),
  }),
  stop_point: z.object({
    id: z.number(),
    designation: z.string().optional(),
  }),
});

export type Departure = z.infer<typeof departureSchema>;

export const stopDeviationSchema = z.object({
  importance_level: z.number(),
  message: z.string(),
  scope: z.object({
    lines: z.array(lineSchema).optional(),
    stop_points: z.array(z.object({ id: z.number().optional() })).optional(),
    stop_areas: z.array(z.object({ id: z.number().optional() })).optional(),
  }),
});

export type StopDeviation = z.infer<typeof stopDeviationSchema>;

export const departureResponse = z.object({
  departures: z.array(departureSchema).optional(),
  stop_deviations: z.array(stopDeviationSchema),
});
